import { VISITED_FOLDER } from 'app/Router/const';
import { DELETE_CONTENT_OR_FOLDER_SUCCESS } from 'app/UserInfo/const';

import {
  CWD_CHANGED,
  ADD_FOLDER_REQUEST_FULFILLED,
  ADD_FOLDER_REQUEST_REJECTED,
  GET_FOLDER_REQUEST_FULFILLED,
  GET_FOLDER_REQUEST_REJECTED,
  UPDATE_FOLDER_REQUEST_FULFILLED
} from './const';

/**
 * a reducer for content tree state
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
const reducer = function treeReducer(state = {}, action = {}) {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case VISITED_FOLDER:
      return { ...state, cwd: action.payload.id };
    case CWD_CHANGED:
      return { ...state, cwd: action.folderID };
    case GET_FOLDER_REQUEST_FULFILLED:
      return { ...state, [action.folderID]: action.payload };
    case GET_FOLDER_REQUEST_REJECTED:
      console.warn(
        `getFolder for '${action.folderID}' request failed with error (${action.error})`
      );
      return state;
    case ADD_FOLDER_REQUEST_FULFILLED: {
      const oldData = state[action.parentFolderID] || {};
      const oldChildren = oldData.Children || [];
      const children = [
        ...oldChildren,
        {
          Id: action.payload.Id,
          Name: action.folderName,
          Type: 'folder'
        }
      ];
      const newData = { ...oldData, Children: children };
      return { ...state, [action.parentFolderID]: newData };
    }
    case ADD_FOLDER_REQUEST_REJECTED:
      console.warn(
        `addFolder for '${action.folderName}' request failed with error (${action.error})`
      );
      return state;
    case DELETE_CONTENT_OR_FOLDER_SUCCESS: {
      if (action.parentId) {
        const parentFolderData = state[action.parentId] || {};
        const newChildren = parentFolderData.Children.filter(
          child => child.Id !== action.contentId
        );
        const newData = { ...parentFolderData, Children: newChildren };
        return { ...state, [action.parentId]: newData };
      }
      return state;
    }
    case UPDATE_FOLDER_REQUEST_FULFILLED: {
      const parentFolderData = state[action.parentFolderID] || {};
      const fIndex = parentFolderData.Children.findIndex(
        child => child.Id === action.payload.Id
      );
      const updatedFolder = { ...parentFolderData.Children[fIndex], Name: action.folderName };
      const newChildren = [
        ...parentFolderData.Children.slice(0, fIndex),
        updatedFolder,
        ...parentFolderData.Children.slice(fIndex + 1)
      ];
      const newData = { ...parentFolderData, Children: newChildren };
      return { ...state, [action.parentFolderID]: newData };
    }
    default:
      return state;
  }
};

export default reducer;
